"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _emotion = require("../../utils/emotion");
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _AssetsBody = _interopRequireDefault(require("../AssetsBody"));
var _ComponentsBody = _interopRequireDefault(require("../ComponentsBody"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultTabs = [];
var OverlapBody = function OverlapBody(props) {
  var open = props.open,
    value = props.value,
    _props$tabs = props.tabs,
    tabs = _props$tabs === void 0 ? defaultTabs : _props$tabs;
  var rootClass = (0, _useCss["default"])(function (theme) {
    return {
      flexGrow: 1,
      flexShrink: 1,
      overflow: 'hidden',
      borderTop: "2px solid ".concat(theme.palette.accent.primary.color)
    };
  });
  var paneClass = (0, _useCss["default"])(function () {
    return {
      width: '100%',
      height: '100%',
      overflow: 'hidden',
      display: 'none'
    };
  });
  var openPaneClass = (0, _useCss["default"])(function () {
    return {
      display: 'block'
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: rootClass,
    children: tabs.map(function (tab, index) {
      var isOpen = index === value && open;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _emotion.cx)(paneClass, isOpen && openPaneClass),
        children: [tab.type === 'assets' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_AssetsBody["default"], _objectSpread({
          open: isOpen
        }, tab)), tab.type === 'components' && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ComponentsBody["default"], _objectSpread({
          open: isOpen
        }, tab))]
      }, index);
    })
  });
};
var _default = OverlapBody;
exports["default"] = _default;